import { render, staticRenderFns } from "./MessageSendCount.vue?vue&type=template&id=e20b25a8&scoped=true&"
import script from "./MessageSendCount.vue?vue&type=script&lang=ts&"
export * from "./MessageSendCount.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendCount.vue?vue&type=style&index=0&id=e20b25a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20b25a8",
  null
  
)

export default component.exports